//#region frontend/islands/toc-scroll-list.js
var TocScrollList = class extends window.HTMLElement {
	connectedCallback() {
		this.list = this.querySelector("ol, ul");
		this.topFade = this.querySelector("[data-toc-fade=\"top\"]");
		this.bottomFade = this.querySelector("[data-toc-fade=\"bottom\"]");
		this.nav = this.closest("nav");
		if (!this.list || !this.nav) return;
		this.updateHeight = this.updateHeight.bind(this);
		this.updateFades = this.updateFades.bind(this);
		this.list.addEventListener("scroll", this.updateFades, { passive: true });
		this.resizeObserver = new window.ResizeObserver(this.updateHeight);
		this.resizeObserver.observe(this.nav);
		this.headerObserver = new window.MutationObserver(this.updateHeight);
		this.headerObserver.observe(document.documentElement, { attributeFilter: ["class"] });
		window.addEventListener("resize", this.updateHeight);
		this.updateHeight();
	}
	updateHeight() {
		const rootStyle = getComputedStyle(document.documentElement);
		const headerHidden = document.documentElement.classList.contains("header-hidden");
		const gutter = parseFloat(rootStyle.getPropertyValue("--gutter")) || 0;
		const headerHeight = (parseFloat(rootStyle.getPropertyValue("--h-announcement")) || 0) + (headerHidden ? 0 : parseFloat(rootStyle.getPropertyValue("--h-header")) || 0);
		const viewportBudget = window.innerHeight - headerHeight - gutter - gutter;
		const navStyle = getComputedStyle(this.nav);
		const navPadding = parseFloat(navStyle.paddingTop) + parseFloat(navStyle.paddingBottom);
		const siblingsHeight = Array.from(this.nav.children).reduce((sum, child) => {
			return child === this ? sum : sum + child.getBoundingClientRect().height;
		}, 0);
		const available = viewportBudget - navPadding - siblingsHeight;
		this.list.style.maxHeight = `${Math.max(available, 0)}px`;
		this.updateFades();
	}
	updateFades() {
		const { scrollTop, scrollHeight, clientHeight } = this.list;
		const isScrollable = scrollHeight > clientHeight + 1;
		const atTop = scrollTop <= 1;
		const atBottom = scrollTop + clientHeight >= scrollHeight - 1;
		this.topFade?.classList.toggle("opacity-0", !isScrollable || atTop);
		this.bottomFade?.classList.toggle("opacity-0", !isScrollable || atBottom);
	}
	disconnectedCallback() {
		this.list?.removeEventListener("scroll", this.updateFades);
		this.resizeObserver?.disconnect();
		this.headerObserver?.disconnect();
		window.removeEventListener("resize", this.updateHeight);
	}
};
window.customElements.define("toc-scroll-list", TocScrollList);
//#endregion
